// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".center[data-v-ac4dc15c]{display:flex;flex-direction:column;justify-content:center;align-content:center}", ""]);
// Exports
module.exports = exports;
